import { render } from "./header-page.vue?vue&type=template&id=63e449f4"
import script from "./header-page.vue?vue&type=script&lang=js"
export * from "./header-page.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__